import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const STATUS_OPTIONS = [
  { value: "pending", label: "Pending", color: "#F59E0B" },
  { value: "in_progress", label: "In Progress", color: "#3B82F6" },
  { value: "editing_done", label: "Editing Done", color: "#8B5CF6" },
  { value: "approved", label: "Approved", color: "#10B981" },
  { value: "posted", label: "Posted", color: "#E4E4E7" },
];

export const ROLE_LABELS = {
  admin: "Admin",
  editor: "Editor",
  smm: "SMM",
  client: "Client",
  pending: "Pending",
};

export const TASK_TYPES = [
  { value: "video_edit", label: "Video Edit" },
  { value: "ad_creative", label: "Ad Creative" },
  { value: "revision", label: "Revision" },
  { value: "design_post", label: "Design / Post" },
  { value: "reel", label: "Reel" },
  { value: "campaign", label: "Campaign" },
  { value: "other", label: "Other" },
];

export const DOXICO_LOGO =
  "https://customer-assets.emergentagent.com/job_task-flow-hub-40/artifacts/a4tdef8e_doxico_logo%20white.png";
export const DOXICO_LOGO_DARK =
  "https://customer-assets.emergentagent.com/job_task-flow-hub-40/artifacts/59et35x8_doxico_logo.png";
